import { Component } from '@angular/core';

@Component({
  selector: 'app-il-09-35-07-02',
  standalone: true,
  imports: [],
  templateUrl: './il-09-35-07-02.component.html',
  styleUrl: './il-09-35-07-02.component.scss'
})
export class Il093572Component {

}
